import { Document } from "@react-pdf/renderer";
import { PmmGuardianSimulatorPage } from "../pages/solution/PmmGuardianSimulatorPage";
import {
  PmmGuardianSimulatorProps,
  PmmGuardianSimulatorResultProps,
} from "../../../interfaces/interfaces";

interface Props {
  data: PmmGuardianSimulatorProps;
  results: PmmGuardianSimulatorResultProps;
}

export const PdfPmmGuardianFile = ({ data, results }: Props) => {
  return (
    <Document>
      <PmmGuardianSimulatorPage data={data} results={results} />
    </Document>
  );
};
